import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-failed-products-dialog',
  templateUrl: './failed-products-dialog.component.html',
  styleUrls: ['./failed-products-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FailedProductsDialogComponent implements OnInit {
  failedListProducts: any[] = [];

  displayedColumns: string[] = [
    'productCode',
    'message'
  ];
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data:any,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    if(this.data?.failedProducts.length){
      this.failedListProducts = this.data.failedProducts;
    }
  }

}
